(function () {
  const openCustomModalBtns = document.querySelectorAll("[data-custom-kit-add-to-cart]");
  const customModalContainer = document.querySelector("[data-custom-modal-container]");
  let selectedProducts = new Set();
  let kitProduct = null;
  let productsData = {};

  openCustomModalBtns.forEach((btn) => {
    btn.addEventListener("click", function(event) {
      // Only proceed if click is from an element with data-open-custom-modal attribute
      if (!event.target.closest('[data-open-custom-modal]')) {
        return;
      }
      
      // Only proceed if click is on the button itself or its immediate children
      if (event.target === btn || btn.contains(event.target)) {
        openCustomModal(event);
      }
    });
  });

  function openCustomModal(event) {
    const blockElement = event.currentTarget.closest('.packages__wrapper');
    if (!blockElement) return;


    // Get kit product data using the correct attribute from kit.js
    kitProduct = {
      id: parseInt(blockElement.getAttribute('data-custom-kit-add-to-cart')),
      price: parseInt(blockElement.dataset.kitPrice),
      title: blockElement.dataset.kitTitle,
      };

    const blockId = blockElement.getAttribute('data-block-id');
    const additionalProductsScript = document.querySelector(`script[data-additional-products="${blockId}"]`);
    if (!additionalProductsScript) return;

    const additionalProducts = JSON.parse(additionalProductsScript.innerHTML);
    
    // Store products with their variant IDs
    productsData = {};
    additionalProducts.forEach(product => {
      productsData[product.variant_id] = {
        id: parseInt(product.variant_id),
        price: parseInt(product.price),
        title: product.title,
        tag: product.tags
      };
    });
    console.log(productsData);

    populateModal(additionalProducts);
    updateTotalPrice();
    updateButtonText();
    customModalContainer.classList.add("is-visible");

    // Add event listeners
    const closeBtn = customModalContainer.querySelector("[data-custom-modal-close]");
    const addAllBtn = customModalContainer.querySelector("[data-add-all-to-cart]");
    
    closeBtn.addEventListener("click", closeCustomModal);
    addAllBtn.addEventListener("click", addAllToCart);
    
    customModalContainer.addEventListener("click", function(e) {
      if (e.target === customModalContainer) {
        closeCustomModal();
      }
    });
  }

  function updateTotalPrice() {
    const totalPriceElement = customModalContainer.querySelector("[data-total-price]");
    let total = 0;

    // Add kit price if exists
    if (kitProduct && kitProduct.price) {
      total += kitProduct.price;
    }

    // Add selected products prices
    selectedProducts.forEach(productId => {
      const product = productsData[productId];
      if (product && product.price) {
        total += product.price;
      }
    });

    totalPriceElement.textContent = formatMoney(total);
  }

  window.handleAddonToggle = function(button, variantId) {
    const isSelected = button.classList.toggle('selected');
    button.textContent = isSelected ? window.theme.strings.selected : window.theme.strings.addOn;
    
    if (isSelected) {
      selectedProducts.add(variantId);
    } else {
      selectedProducts.delete(variantId);
    }
    
    updateTotalPrice();
    updateButtonText();
  };

  function updateButtonText() {
    const buttonText = customModalContainer.querySelector('[data-button-text]');
    const hasSelectedProducts = selectedProducts.size > 0;
    
    buttonText.textContent = hasSelectedProducts 
      ? window.theme.strings.continueCheckout 
      : window.theme.strings.noThanks;
  }

  let isAddingToCart = false;

  async function addAllToCart(event) {
    event.target.disabled = true;

    if (isAddingToCart) return;
    isAddingToCart = true;
  
    const addAllBtn = customModalContainer.querySelector("[data-add-all-to-cart]");
    const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    const kitButtons = document.querySelectorAll('[data-open-custom-modal]');
  
    try {
      // Check if kit already exists in cart
      const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
      const cartData = await cartResponse.json();
      const hasKit = cartData.items.some(item =>
        item.product_type === 'Kit' ||
        (item.properties && item.properties._set_type === "Kit")
      );
  
      if (hasKit) {
        const errorMessage = window.theme.strings.errors.limitOneProduct;
        addAllBtn.classList.remove('is-loading');
  
        const errorContainer = customModalContainer.querySelector('.error-message') || 
          document.createElement('div');
        errorContainer.className = 'error-message';
        errorContainer.textContent = errorMessage;
        addAllBtn.parentNode.insertBefore(errorContainer, addAllBtn.nextSibling);
  
        setTimeout(() => {
          errorContainer.remove();
        }, 3000);
  
        return;
      }
  
      addAllBtn.classList.add('is-loading');
  
      const formData = {
        items: []
      };
  
      // Add kit product first
      if (kitProduct && kitProduct.id) {
        formData.items.push({
          id: kitProduct.id,
          quantity: 1,
          properties: {
            _commissionable: 'Non-Commissionable',
            _set_type: "Kit",
            _set_commissionable: 'Commissionable',
            _bundle: 'Kit Package',
            _kit_id: kitProduct.id,
            _kit_title: kitProduct.title
          }
        });
      }
  
      // Add selected products with reference to the kit
      selectedProducts.forEach(variantId => {
        if (productsData[variantId]) {
          formData.items.push({
            id: parseInt(variantId),
            quantity: 1,
            properties: {
              _commissionable: 'Commissionable',
              _set_type: "Kit Add-On",
              _set_commissionable: 'Commissionable',
              _bundle: 'Kit Add-on',
              _parent_kit_id: kitProduct.id,
              _parent_kit_title: kitProduct.title,
              _parent_line_item: `Kit - ${kitProduct.title}`
            }
          });
        }
      });
  
      // Add items to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
  
      // Show success state
      addAllBtn.classList.remove('is-loading');
      addAllBtn.classList.add('is-complete');
  
      // Reload cart and trigger drawer
      document.dispatchEvent(
        new CustomEvent('theme:cart:init', {
          bubbles: true
        })
      );
      document.dispatchEvent(
        new CustomEvent("theme:cart:reload", {
          bubbles: true
        })
      );
  
      setTimeout(() => {
        closeCustomModal();
        addAllBtn.classList.remove('is-complete');
        
        // Disable all kit buttons
        kitButtons.forEach(btn => {
          btn.classList.add('disabled');
          btn.disabled = true;
        });
  
        // Open drawer using the same method as bundle-fixed.js
        cartDrawer.dispatchEvent(
          new CustomEvent('theme:drawer:open', {
            bubbles: true
          })
        );
      }, 1500);
  
    } catch (error) {
      console.error('Error adding to cart:', error);
      addAllBtn.classList.remove('is-loading');
      alert('Error adding items to cart. Please try again.');
    } finally {
      isAddingToCart = false;
      event.target.disabled = false;
    }
  }
  

  function closeCustomModal() {
    customModalContainer.classList.remove("is-visible");
    // Reset selected products
    selectedProducts.clear();
    // Reset button states
    const addAllBtn = customModalContainer.querySelector("[data-add-all-to-cart]");
    if (addAllBtn) {
      addAllBtn.classList.remove('is-loading', 'is-complete');
    }
  }

  function populateModal(productList) {
    const productListContainer = customModalContainer.querySelector("[data-product-list]");
    productListContainer.innerHTML = productList.map(product => `
      <li class="product-list-item">
      ${product.tags && product.tags.includes("best-value") ? `<div class="badge best-value">${window.theme.strings.bestValue || 'Best Value'}</div>` : ''} <img
      <img
          src="${product.image_url}" 
          alt="${product.title}"
          width="120"
          height="120"
          loading="lazy"
        >
        <div class="product-info">
          <div class="product-info-text">
            <p class="product-title">${product.title}</p>
            <p class="product-price">${formatMoney(product.price)}</p>
          </div>
          <button 
            class="addon-btn${selectedProducts.has(product.variant_id) ? ' selected' : ''}" 
            data-product-id="${product.variant_id}"
            onclick="handleAddonToggle(this, ${product.variant_id})"
          >
            ${selectedProducts.has(product.variant_id) ? window.theme.strings.selected : window.theme.strings.addOn}
          </button>
        </div>
      </li>
    `).join('');
  }

  function formatMoney(cents) {
    const formatString = window.theme?.moneyFormat || "${{amount}}";
    
    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    return formatString.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, amount) {
      return formatWithDelimiters(cents, 2);
    });
  }
})(); 